<template>
  <el-container height="auto">
    
    <el-main>

      <el-form :model="pwdform" status-icon :rules="pwdformrules" ref="pwdform" label-width="100px">
        <el-form-item label="旧密码" prop="password">
          <el-col :span="12">
            <el-input show-password v-model="pwdform.password" placeholder="请输入当前密码"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="新密码" prop="newpassword">
          <el-col :span="12">
            <el-input show-password v-model="pwdform.newpassword" placeholder="8-14位，建议英文、数字、下划线组合"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="确认新密码" prop="checknewpasssword">
          <el-col :span="12">
            <el-input show-password v-model="pwdform.checknewpasssword" placeholder="8-14位，建议英文、数字、下划线组合"></el-input>
          </el-col>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm('pwdform')">提交</el-button>
          <el-button @click="resetForm('pwdform')">重置</el-button>
        </el-form-item>
      </el-form>

       
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.pwdform.checknewpasssword !== '') {
            this.$refs.pwdform.validateField('checknewpasssword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.pwdform.newpassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        pwdform: {
          password:'',
          newpassword:'',
          checknewpasssword:'',
        },
        userinfo:{},
        pwdformrules: {
          password:[
            { required: true, message: '请输入当前密码', trigger: 'blur' }
          ],
          newpassword: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' }
          ],
          checknewpasssword: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        
      }
    },
    mounted(){
      this.getProfile();
    },
    methods: {
      getProfile(){
        this.$http.get('user/profile').then((res) => {
            this.userinfo = res.data.info;
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            
            if(this.userinfo.userpassword !== this.pwdform.password){
              this.$message({type:'error',message:'密码输入错误！'})
            }
            else{
              let postdata ={
                userid :this.userinfo.userid,
                userpassword:this.pwdform.newpassword,
              }

              this.$http.post('user/changepwd', postdata).then((res) => {
                  if(!res) return;
                  //提醒成功
                  this.userinfo.userpassword = this.pwdform.newpassword;
                  this.$message({ type:'success', message:'密码已成功修改,请牢记此密码。'})
              }); 
            }


            
          } else {
            
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // onSave(){

      //   this.$refs["form"].validate(valid=>{
      //     if(valid){

      //       let postdata = {
      //         username:this.form.username,
      //         title:this.form.title || '',
      //         hospital:this.form.hospital || '',
      //         department:this.form.department || '',
      //         comments:this.form.comments || '',
      //         email:this.form.email || '',
      //         phone:this.form.phone || '',
              
      //       };

      //       if(this.form.shenshi || '' !='')
      //       {
      //         postdata.province = this.form.shenshi[0];
      //         postdata.city = this.form.shenshi[1];
      //       }
      //       else{
      //         postdata.province = '';
      //         postdata.city = '';
      //       }
            
      //       this.$http.post('user/edit', postdata).then((res) => {
      //           if(!res) return;

      //           //提醒成功
      //           this.$message({ type:'success', message:'个人资料已更新'})
                
      //       }); 

      //     }
      //   })

        
      // },
      
    }
  }
</script>
<style scoped>

</style>